import request from '../request'

export default {
    getEnviroment() {
        return request.get('/env')
    }
}
